import axios from '../utils/axios';

export default function updateCETestimonial(adminId, id, data) {
    return (
        axios.post('/admin/' + adminId +'/client-engagement/testimonials/' + id + '/update',  data )
    )
}